// src/api/scriptsApi.js
import axiosInstance from '../APInterceptors';
import { endpoint } from '../endpoint';
import { apiUrl } from '../../utils/apiUrl';

// Create Script
export const CreateScript = async (data: any) => {
  const { formData } = data;
  try {
    const response = await axiosInstance.post(endpoint.scripts, formData);
    return response;
  } catch (error) {
    throw error;
  }
};


// Update Script
export const UpdateScript = async (data: any) => {
  const { formData, scriptId } = data;
  try {
    const response = await axiosInstance.patch(
      `scripts/upload/${scriptId}/`,
      formData,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Get Script by ID
export const GetScriptByID = async (data: any) => {
  const { id } = data;
  try {
    const response = await axiosInstance.get(`${endpoint.scripts}/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// Get Public Script by ID (no authentication required)
export const GetPublicScriptByID = async (data: any) => {
  const { id } = data;
  try {
    const response = await fetch(apiUrl(`public/scripts/${id}`), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const responseData = await response.json();
    return { data: responseData };
  } catch (error) {
    throw error;
  }
};

// Delete Script by ID
export const DeleteScriptByID = async (data: any) => {
  const { id } = data;
  try {
    const response = await axiosInstance.delete(`${endpoint.scripts}/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// Get All Scripts
export const GetAllScript = async ({ page = 1, per_page, query = '' }: any) => {
  try {
    // The trailing separator is dropped when there is no extra query, so the
    // request reads as a clean address rather than one ending in an ampersand.
    const extra = query ? `&${query}` : '';
    const response = await axiosInstance.get(
      `${endpoint.scripts}?page=${page}&per_page=${per_page}${extra}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
// Get Scripts by Category
export const GetScriptbyCategory = async (data: any) => {
  const { value } = data;
  try {
    // Build query parameters dynamically
    const params = new URLSearchParams();
    // The page used to be pinned to 1, so a filtered result set could never be
    // paged past its first page however many scripts matched.
    params.append('page', String(value?.page || 1));
    if (value?.per_page) params.append('per_page', String(value.per_page));

    if (value?.category) params.append('category', value.category);
    if (value?.category1) params.append('subcategory1', value.category1);

    // Free text search and sort are resolved by the server, so they apply to
    // every matching script rather than to the rows already on screen.
    if (value?.search) params.append('search', value.search);
    if (value?.ordering) params.append('ordering', value.ordering);

    // Handle new problems/stale_hours parameters
    if (value?.problems) {
      params.append('problems', value.problems);
      if (value?.stale_hours) {
        params.append('stale_hours', value.stale_hours);
      }
    } else if (value?.status && value.status !== '') {
      // Only use status filter if not using problems filter
      params.append('status', value.status === 'all' ? '' : value.status);
    }
    
    const response = await axiosInstance.get(
      `${endpoint.scripts}?${params.toString()}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
// Get status Script by ID
export const GetSatusScriptByID = async (data: any) => {
  const { id } = data;

  try {
    const response = await axiosInstance.get(
      `${endpoint.scripts}/${id}/status`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
// Run Script
export const RunScript = async ({ id }: any) => {
  try {
    const response = await axiosInstance.post(`${endpoint.scripts}/${id}/run`);
    return response;
  } catch (error) {
    throw error;
  }
};
